/**
 * Format additive probe outcome fields for Gate 1 API surface display.
 * Does not invent values — only renders what the report already contains.
 */

function labelPassFail(value) {
  const v = String(value || "").toLowerCase();
  if (v === "passed" || v === "pass") return { text: "PASS", tone: "pass" };
  if (v === "failed" || v === "fail") return { text: "FAIL", tone: "fail" };
  return null;
}

/**
 * @param {object} probeResult
 * @returns {Array<{ key: string, title: string, text: string, tone: "pass" | "fail" }>}
 */
export function probeOutcomeDisplayItems(probeResult) {
  if (!probeResult || typeof probeResult !== "object") return [];
  const items = [];

  const connection = labelPassFail(probeResult.connection);
  if (connection) {
    items.push({ key: "connection", title: "Connection", ...connection });
  }

  const operation = labelPassFail(probeResult.operation);
  if (operation) {
    items.push({ key: "operation", title: "Operation", ...operation });
  }

  if (probeResult.response && typeof probeResult.response === "object") {
    const valid = probeResult.response.valid;
    if (valid === true) {
      items.push({ key: "response", title: "Response", text: "VALID", tone: "pass" });
    } else if (valid === false) {
      items.push({ key: "response", title: "Response", text: "INVALID", tone: "fail" });
    }
  }

  return items;
}
